const FETCH_HISTORY_SUCCESS = 'app/history/FETCH_HISTORY_SUCCESS'

export {
  FETCH_HISTORY_SUCCESS
}
